import { defineStyleConfig } from "@chakra-ui/react";
import { merge } from "es-toolkit/compat";

import { Input } from "./input";

export const Textarea = merge(
  {},
  Input,

  defineStyleConfig({
    baseStyle: {
      resize: "vertical",
    },

    variants: {
      outline: {
        ...Input.variants?.outline.field,

        height: "24",
      },
    },
  }),
);
